export default function checkAutoFill () {


  /*
   * make a function to use it in multiple places
   */
  var checkAutoFill = function(){
    $('input:-webkit-autofill').closest('.form-control').parent().addClass('filled');
  }

  /*
   * trigger it also inside a timeOut event
   * (happens after chrome auto-filled fields on page-load)
   */
  setTimeout(function(){
      checkAutoFill();
  }, 250);

};
